import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

/**
 * Root component of the ZenBasket Analytics application.
 * Provides the main application shell and hosts the Angular router outlet,
 * which is responsible for rendering the active routed component.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  /**
   * The Document object is injected to allow direct manipulation of the DOM.
   * In this component, it is used to remove the loading spinner element from the DOM once
   * the application has fully loaded and the first NavigationEnd event is fired, ensuring that
   * the user interface is clean and free of loading indicators after the app is ready for interaction.
   */
  private document = inject(DOCUMENT);
  /**
   * Router is used for navigating between different routes in the application.
   * In this component, it is used to navigate the user to the sign-in page when a
   * logout event is received through the BroadcastChannel, ensuring that the user is redirected
   * appropriately after logging out from any tab.
   */
  private router = inject(Router);
  /**
   * Application title used by the root component.
   * Stored as an Angular signal so the value can be reactively
   * consumed by the component template.
   */
  protected readonly title = signal('zenbasket-analytics');
  /**
   * After the view initializes, this method listens for the first NavigationEnd event to remove the loading spinner from the DOM, ensuring that it only happens once when the application is fully loaded.
   */
  ngAfterViewInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1))
      .subscribe(() => {
        const loader = this.document.getElementById('admin-loader-container');
        loader?.remove();
      });
  }
}